import React, { PropTypes } from 'react';
import ScoreCell from './ScoreCell';

const cellId = (product, answer) => product.id + '_' + answer.id;

const AnswerRow = ({ answer, products, ...others }) => {
  return (
    <div className="tr">
      <div className="td response">{answer.content}</div>
      {products.map(product => (
        <ScoreCell
          key={cellId(product, answer)}
          answer={answer}
          product={product}
          exclusions={product.exclusions}
          {...others}
        />
      ))}
    </div>
  );
};

AnswerRow.propTypes = {
  answer: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
};

export default AnswerRow;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/scoring/AnswerRow.js